// import school icon 
import { CalendarDays, IndianRupee, School2, LayoutDashboard, LogOut } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const navigation = [
  { to: "/admin/exam-dates", label: "Exam Dates", icon: CalendarDays },
  { to: "/admin/exam-prices", label: "Exam Prices", icon: IndianRupee },
  { to: "/admin/registered-schools", label: "Registered Schools", icon: School2 },
];

const AdminSideBar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("uc_admin_token");
    navigate("/admin/login");
  };

  return (
    <aside className="w-full shrink-0 p-3 pb-0 sm:px-5 lg:w-64 lg:p-5 lg:pr-0">
      <div className="flex flex-col rounded-2xl border border-slate-200 bg-white p-4 text-slate-900 shadow-sm lg:sticky lg:top-5">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-sky-100 text-sky-700">
            <LayoutDashboard className="h-5 w-5" />
          </div>
          <div className="text-left">
            <p className="font-bold">Admin</p>
            <p className="text-xs text-slate-500">Unified Council</p>
          </div>
        </div>

        <nav className="flex gap-2 overflow-x-auto lg:flex-col" aria-label="Admin navigation">
          {navigation.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `flex min-w-fit items-center gap-3 rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${
                isActive ? "bg-sky-600 text-white shadow-sm" : "bg-slate-100 text-slate-600 hover:bg-sky-100 hover:text-sky-800"
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-3 border-t border-slate-200 pt-3">
          <Button
            type="button"
            variant="ghost"
            onClick={handleLogout}
            className="h-11 w-full justify-start gap-3 rounded-xl bg-rose-50 px-3 font-semibold text-rose-700 transition-colors hover:bg-rose-100 hover:text-rose-800"
          >
            <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-white text-rose-600 shadow-sm">
              <LogOut className="h-4 w-4" />
            </span>
            Logout
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default AdminSideBar;
